import { LogoWrapper } from '@anm/components/Logo/Wrapper';
import Button from '@anm/components/buttons/Button/Button';
import IconButton from '@anm/components/buttons/IconButton';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

export const UserMenuWrapper = styled.div``;

const customizationHeaderButtonsMobile = media.tablet`
  flex-wrap: wrap;
`;

const customizationHeaderButtonsResponsive = media.desktop_small`
  margin: 20px 0 0;
  justify-content: space-between;
  ${Button} {
    &:first-child:last-child {
      width: 100%
    }
  }
`;

export const CustomizationHeaderButtons = styled.div`
  display: flex;
  margin: 0 20px 0 auto;
  & > *,
  & > ${Button} {
    margin: 0 5px;
    flex: 1;
  }
  ${customizationHeaderButtonsResponsive};
  ${customizationHeaderButtonsMobile};
`;

const wrapperLaptop = media.desktop_small`
  border-bottom: 0 none;
  min-height: 54px;
  padding: 18px 19px 0;
  flex-wrap: wrap;
  ${UserMenuWrapper} {
    order: 2;
  }
  ${CustomizationHeaderButtons} {
    order: 3;
    min-width: 100%
  }
  ${Button} {
    min-width: auto;
    margin-bottom: 10px;
  }
`;

const wrapperTablet = media.tablet`
  ${LogoWrapper}, ${UserMenuWrapper} {
    display: none
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 40px 15px 22px;
  justify-content: space-between;
  border-bottom: 1px solid #ccdde6;
  min-height: 75px;
  z-index: 7;
  background-color: #fff;
  position: sticky;
  top: 0;
  ${LogoWrapper} {
    margin-right: 10px;
  }
  ${Button} {
    min-width: 140px;
    width: 100%;
  }
  ${wrapperTablet};
  ${wrapperLaptop};
`;

export const CustomizationBreadcrumbWrapper = styled(Wrapper)<{ isSemrush: boolean }>`
  padding: 12px 40px 12px 22px;
  min-height: auto;
  position: sticky;
  top: ${({ isSemrush }) => isSemrush ? 0 : 81};
  z-index: 6;
  padding-right: ${({ isSemrush }) => isSemrush ? 0 : 40}px;
`;

export const ShareButtonWrapper = styled(IconButton)`
  padding: 0 20px;
  min-width: 150px;
  line-height: 19px;
  font-weight: bold;

  &:before {
    margin-right: 12px;
  }
`;
